import { cloneDeep } from 'lodash';
const SET_SEARCH_LOADING = 'SET_SEARCH_LOADING';
const SET_SEARCH_LOADING_FALSE = 'SET_SEARCH_LOADING_FALSE';

const initialStateSearchLoading = false;

export default function reducer(state = cloneDeep(initialStateSearchLoading), action) {
	switch (action.type) {
		case SET_SEARCH_LOADING:
			return true;
		case SET_SEARCH_LOADING_FALSE:
			return false;
		default:
			return state;
	}
}

export function fireSearchLoading(){
	return { type: SET_SEARCH_LOADING }
}

export function setSearchLoadingFalse(){
	return { type: SET_SEARCH_LOADING_FALSE }
}



// WEBPACK FOOTER //
// ./src/modules/search_loading.js